export default __webpack_public_path__ + "static/media/banner_xl.8a9fe032.svg";